export enum LegalClientBodyType {
  /** Высший орган */
  SupremeBody = 'SupremeBody',
  /** Орган управления */
  ManagementBody = 'ManagementBody',
  /** Исполнительный орган */
  ExecutiveBody = 'ExecutiveBody',
  /** Иной орган — пользователь может ввести свой тип */
  Other = 'Other',
}
export interface LegalClientBodyEntity {
  id: string;
  createdAt: Date;
  type: LegalClientBodyType;
  name: string;
  archived?: boolean;
  otherType?: string;
}
